module.exports = __webpack_public_path__ + "fonts/Chap-Medium.ed221ee0.otf";